module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/number-icon-1.5eb6a3e2.svg";